
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42 20.999c0 11.598-9.402 21-21 21s-21-9.402-21-21 9.402-21 21-21 21 9.402 21 21zm-8.453 10.348V22.69c0-4.636-2.476-6.794-5.778-6.794-2.667 0-3.857 1.468-4.524 2.494v-2.14h-5.02c.067 1.417 0 15.098 0 15.098h5.02v-8.432c0-.452.034-.9.166-1.223.364-.903 1.188-1.836 2.574-1.836 1.818 0 2.543 1.385 2.543 3.414v8.077h5.02zM23.245 18.39v.05h-.033c.004-.009.01-.017.017-.026a.376.376 0 00.016-.024zm-13.112-6.808c0-1.481 1.123-2.608 2.84-2.608 1.718 0 2.773 1.127 2.806 2.608 0 1.45-1.088 2.609-2.84 2.609h-.032c-1.684 0-2.774-1.16-2.774-2.61zm5.316 19.766h-5.018V16.25h5.018v15.097z","fill":"#F1F2F2"}})])
          )
        }
      }
    